import React, { useState, useEffect } from 'react';
import JoinDiscordStep1 from './JoinDiscordStep1';
import JoinDiscordStep2 from './JoinDiscordStep2';
import JoinDiscordStep3 from './JoinDiscordStep3';
import StepTracker from './StepTracker';
import { BACKEND_URL } from '../config';

const JoinDiscordPage = () => {
  const [discordLink, setDiscordLink] = useState('');
  const [token, setToken] = useState('');
  const [currentStep, setCurrentStep] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    const savedToken = sessionStorage.getItem('onboarding_token');

    const finalToken = tokenParam || savedToken;

    if (finalToken) {
      if (tokenParam) {
        sessionStorage.setItem('onboarding_token', tokenParam);
      }
      setToken(finalToken);
      checkDiscordStep(finalToken);
    } else {
      setIsLoading(false);
    }

    fetchDiscordLink();
  }, []);

  const fetchDiscordLink = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/config?resource=discord-link`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      setDiscordLink(data.discordLink || 'https://discord.gg/default');
    } catch {
      setDiscordLink('https://discord.gg/default');
    }
  };

  const checkDiscordStep = async (tokenParam) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/onboarding`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'check-discord-step',
          token: tokenParam,
        }),
      });

      const data = await response.json();

      if (data.discord_join_step === '3/3') {
        window.location.href = `/complete?token=${tokenParam}`;
      } else {
        setCurrentStep(data.discord_join_step || null);
      }
    } catch (err) {
      setCurrentStep(null);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center">
        <div className="text-white text-xl">Cargando...</div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center">
        <div className="text-white text-xl">Token no encontrado</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-4 py-8 overflow-x-hidden relative">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-yellow-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-700"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img src="/logo-nsl.png" alt="NSL Logo" className="h-24 w-auto object-contain" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent mb-2">
            Onboarding NSL
          </h1>
        </div>

        <StepTracker currentStep={6} />

        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-600/20 rounded-2xl shadow-2xl backdrop-blur-xl overflow-hidden">
          <div className="p-6 sm:p-8">
            {(!currentStep || currentStep === null || currentStep === '1/3') && (
              <JoinDiscordStep1 discordLink={discordLink} token={token} />
            )}
            {currentStep === '2/3' && (
              <JoinDiscordStep2 token={token} />
            )}
            {currentStep === '3/3' && (
              <JoinDiscordStep3 token={token} />
            )}
          </div>
        </div>

        <div className="text-center mt-8 text-gray-500 text-sm">
          <p>© {currentYear} No Soy Liquidez. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default JoinDiscordPage;